import React, { useState } from "react"
import PropTypes from "prop-types"
import ModalForm from "../../../../components/compounds/modalForm/ModalForm.compunds"
import PrimaryButton from "../../../../components/molecules/buttons/PrimaryButton.molecule"
import SecondaryButton from "../../../../components/molecules/buttons/SecondaryButton.molecule"
import VacationStatusChip from "../../../../components/molecules/VacationStatusChip.molecule"
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined"
import { cancelVacationRequest } from "../../../../services/vacation.service"
import useToast from "../../../../hooks/useToast.hook"
import {
  VACATION_STATUS_CHIP_VARIANTS,
  VACATION_STATES,
  MY_VACATION_STATES,
  VACATION_APPROVED_STATUS,
  VACATIONS_SAVE_ERROR_MESSAGE,
  VACATIONS_SAVE_SUCCESS_MESSAGE,
} from "../../../../consts/modules/vacations.consts"
import VacationMyRequestSummary from "../../components/VacationMyRequestSummary.molecule"
import {
  isVacationCancelRequest,
  isVacationChangeRequest,
  isVacationRequestApproved,
  isVacationRequestBlocked,
  isVacationRequestCanceled,
  isVacationRequestCanceledByAdmin,
  isVacationRequestPending,
  isVacationRequestRejected,
} from "../../../../utils/vacation.utils"

const ModalMyVacationsRequestReview = ({
  visible,
  setVisible,
  selectedVacationRequest,
  setSelectedVacationRequest,
  triggerRefresh,
}) => {
  // Form States
  const [submitting, setSubmitting] = useState(false)

  // Hooks
  const { setErrorMessage, setSuccessMessage } = useToast()

  const handleSubmit = async () => {
    if (
      selectedVacationRequest.approved !== VACATION_APPROVED_STATUS.APPROVED
    ) {
      setSubmitting(true)
      try {
        const response = await cancelVacationRequest(
          selectedVacationRequest.idVacations
        )
        if (!response.success) {
          throw new Error(response.message)
        }
        setVisible("")
        setSelectedVacationRequest(null)
        triggerRefresh()
        setSuccessMessage(VACATIONS_SAVE_SUCCESS_MESSAGE)
      } catch (error) {
        setErrorMessage(VACATIONS_SAVE_ERROR_MESSAGE)
      }
      setSubmitting(false)
    } else {
      setVisible(MY_VACATION_STATES.CANCEL_APPROVED)
    }
  }

  const handleModalSetVisibility = (visibleModal) => {
    if (!visibleModal) {
      setVisible("")
      // setSelectedVacationRequest(null)
    }
  }

  const handleEditModalSetVisibility = () => {
    if (
      selectedVacationRequest.approved === VACATION_APPROVED_STATUS.APPROVED
    ) {
      setVisible(MY_VACATION_STATES.CHANGE_APPROVED)
    } else {
      setVisible(MY_VACATION_STATES.CHANGE_PENDING)
    }
  }
  const modalSubtitleTemplate = (selectedVacationRequest) => {
    if (!selectedVacationRequest) {
      return null
    }

    if (
      selectedVacationRequest.approved === VACATION_APPROVED_STATUS.NOT_REVIEWED
    ) {
      return (
        <VacationStatusChip
          variant={VACATION_STATUS_CHIP_VARIANTS.LONG}
          status={VACATION_STATES.PENDING}
        />
      )
    } else if (
      selectedVacationRequest.approved === VACATION_APPROVED_STATUS.APPROVED &&
      selectedVacationRequest.approver !== null
    ) {
      return (
        <VacationStatusChip
          variant={VACATION_STATUS_CHIP_VARIANTS.LONG}
          modifierName={selectedVacationRequest.approver.fullName}
          status={VACATION_STATES.APPROVED}
        />
      )
    } else if (
      selectedVacationRequest.approved === VACATION_APPROVED_STATUS.APPROVED &&
      selectedVacationRequest.approver === null
    ) {
      return (
        <VacationStatusChip
          variant={VACATION_STATUS_CHIP_VARIANTS.LONG}
          status={VACATION_STATES.APPROVED}
        />
      )
    } else if (
      selectedVacationRequest.approved === VACATION_APPROVED_STATUS.APPROVED &&
      selectedVacationRequest.vacationsHaveBeenCounted === 1
    ) {
      return (
        <VacationStatusChip
          variant={VACATION_STATUS_CHIP_VARIANTS.LONG}
          status={VACATION_STATES.BLOCKED}
        />
      )
    } else if (isVacationRequestRejected(selectedVacationRequest)) {
      return (
        <VacationStatusChip
          variant={VACATION_STATUS_CHIP_VARIANTS.LONG}
          modifierName={selectedVacationRequest.approver.fullName}
          status={VACATION_STATES.REJECTED}
        />
      )
    } else if (isVacationRequestCanceled(selectedVacationRequest)) {
      return (
        <VacationStatusChip
          variant={VACATION_STATUS_CHIP_VARIANTS.LONG}
          modifierName={selectedVacationRequest.approver.fullName}
          status={VACATION_STATES.CANCELED}
        />
      )
    }
  }

  const modalFooterTemplate = () => {
    return (
      <div>
        <SecondaryButton
          rounded
          kind="outlined"
          icon={`pi pi-ban`}
          label={
            isVacationRequestPending(selectedVacationRequest) ?
              "Cancelar solicitud"
            : "Solicitar cancelación"
          }
          className={"p-button-cancel-vacations"}
          onClick={handleSubmit}
        />
        <PrimaryButton
          rounded
          type="outlined"
          icon={`pi pi-pencil`}
          label={
            isVacationRequestApproved(selectedVacationRequest) ?
              "Solicitar cambio"
            : "Editar solicitud"
          }
          className={"p-button-change-vacations"}
          onClick={handleEditModalSetVisibility}
        />
      </div>
    )
  }

  const validateWithoutFooter = () => {
    if (isVacationRequestBlocked(selectedVacationRequest)) return true
    return (
      isVacationRequestRejected(selectedVacationRequest) ||
      isVacationRequestCanceled(selectedVacationRequest) ||
      (isVacationRequestApproved(selectedVacationRequest) &&
        selectedVacationRequest.plusDaysPayDate !== null) ||
      isVacationChangeRequest(selectedVacationRequest) ||
      isVacationCancelRequest(selectedVacationRequest)
    )
  }

  if (!selectedVacationRequest) {
    return null
  }
  return (
    <ModalForm
      className="my-vacation-request-modal-form"
      visible={visible}
      setVisible={handleModalSetVisibility}
      headerTitle="Solicitud de vacaciones"
      headerSubtitle={modalSubtitleTemplate(selectedVacationRequest)}
      footer={modalFooterTemplate}
      withoutFooter={validateWithoutFooter()}
      headerIcon={
        <BeachAccessOutlinedIcon
          style={{ color: "var(--clr-info__dark)", fontSize: "32px" }}
        />
      }
      dismissableMask
      closable
    >
      <VacationMyRequestSummary vacationRequest={selectedVacationRequest} />
    </ModalForm>
  )
}

export default ModalMyVacationsRequestReview

ModalMyVacationsRequestReview.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  selectedVacationRequest: PropTypes.object,
  triggerRefresh: PropTypes.func,
}
